import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { getIntlProviderConfig } from 'app/config/intl';
import { ToastContainer } from 'react-toastify';
import { fetchAppSettings, setFromLogin } from 'app/store/slices/settings';
import auth from 'app/api/auth';
import { getLoggedInUser, logOut } from 'app/store/slices/user';
import { createTheme } from '@material-ui/core';
import InternalRoutes from 'app/components/Routes/InternalRoutes';
import ExternalRoutes from 'app/components/Routes/ExternalRoutes';
import MuiProvider from 'app/layouts/MuiProvider';
import muiTheme from 'app/config/muiTheme';
import Loading from 'app/layouts/Loading';
import { ptBR } from '@material-ui/core/locale';
import GlobalDrawer from 'app/components/GlobalDrawer';

function App() {
    const dispatch = useDispatch();
    const [initialLoading, setInitialLoading] = useState(true);
    const settings = useSelector((state) => state.settings.settings);
    const loading = useSelector((state) => state.settings.loading);
    const intlProviderProps = getIntlProviderConfig(settings.locales);
    const [currentTheme, setCurrentTheme] = useState('servicePortal');

    useEffect(() => {
        const init = async () => {
            if (!!auth.getToken()) {
                try {
                    await getLoggedInUser(dispatch);
                    dispatch(setFromLogin(true));
                } catch (error) {
                    await logOut(dispatch);
                }
            }
            await dispatch(fetchAppSettings());
            setInitialLoading(false);
        };
        init();
    }, [dispatch]);

    const renderAppContainer = () => {
        return (
            <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
                <div className={'generalContainer'}>
                    <Switch>
                        <Route
                            path="/interno/"
                            render={(props) => (
                                <InternalRoutes
                                    {...props}
                                    currentTheme={currentTheme}
                                    setCurrentTheme={setCurrentTheme}
                                />
                            )}
                        />
                        <Route
                            path="/"
                            render={(props) => (
                                <ExternalRoutes
                                    {...props}
                                    currentTheme={currentTheme}
                                    setCurrentTheme={setCurrentTheme}
                                />
                            )}
                        />
                    </Switch>
                </div>
            </BrowserRouter>
        );
    };

    const renderApp = () => {
        const theme = createTheme(muiTheme[currentTheme], ptBR);
        return (
            <>
                {!initialLoading && (
                    <MuiProvider theme={theme}>
                        <IntlProvider locale="pt" {...intlProviderProps}>
                            <>
                                <GlobalDrawer />
                                <ToastContainer
                                    className="toast-container"
                                    position="top-right"
                                    autoClose={10000}
                                    closeButton={true}
                                    draggable={false}
                                    rtl={false}
                                    limit={3}
                                    newestOnTop
                                    closeOnClick
                                    pauseOnVisibilityChange
                                    hideProgressBar
                                    pauseOnHover
                                />
                                <BrowserRouter>{renderAppContainer()}</BrowserRouter>
                            </>
                        </IntlProvider>
                    </MuiProvider>
                )}
            </>
        );
    };

    return (
        <>
            {loading && <Loading />}
            {renderApp()}
        </>
    );
}

export default App;
